module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.startSearch.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.startSearch
    },
    model: {
      value: (_vm.searchFilter),
      callback: function($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.startSearch
    }
  }, [_vm._v(_vm._s(_vm.lang.butSearch))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.searchFilter = '';
        _vm.getRecords();
      }
    }
  }, [_vm._v("C")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.lang.butAdd))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "newscreated",
      "label": "Created",
      "min-width": "129",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "newstitle",
      "label": "Title",
      "min-width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "newsby",
      "label": "By",
      "min-width": "80",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "Size",
      "min-width": "60",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t" + _vm._s(scope.row.newstext ? scope.row.newstext.length : 0) + " bytes\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "100",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "xdisabled": "allowed[0]==false",
            "type": "danger",
            "size": "small",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev,pager,next,jumper,sizes",
      "total": _vm.mainTotal,
      "current-page": _vm.currentPage,
      "page-sizes": [10, 15, 25, 50, 100, 1000],
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " records found")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" News")]), _vm._v(" "), (this.editMode == 'save') ? _c('el-form-item', {
    attrs: {
      "label": "ID :",
      "prop": "id"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['newskey']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'newskey', $$v)
      },
      expression: "editForm['newskey']"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm['newscreated']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'newscreated', $$v)
      },
      expression: "editForm['newscreated']"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Title :",
      "prop": "newstitle"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['newstitle']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'newstitle', $$v)
      },
      expression: "editForm['newstitle']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Text :",
      "prop": "newstext"
    }
  }, [_c('wysiwyg', {
    model: {
      value: (_vm.editForm['newstext']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'newstext', $$v)
      },
      expression: "editForm['newstext']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Hot news :"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "red",
      "inactive-color": "#ccc"
    },
    model: {
      value: (_vm.editForm['hotnews']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'hotnews', $$v)
      },
      expression: "editForm['hotnews']"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" More")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Image :",
      "prop": "newsimage"
    }
  }, [_c('el-input', {
    attrs: {
      "title": "Use public or relative url, like: 'http://server/image.jpg', '/static/img/tui-logo.png' or empty for none.",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['newsimage']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'newsimage', $$v)
      },
      expression: "editForm['newsimage']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Link :",
      "prop": "newslink"
    }
  }, [_c('el-input', {
    attrs: {
      "title": "Use public or relative url, like: 'http://server/page.html' or empty for none.",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['newslink']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'newslink', $$v)
      },
      expression: "editForm['newslink']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Show From/To :"
    }
  }, [_c('el-date-picker', {
    staticClass: "startTimeBox",
    attrs: {
      "type": "date",
      "clearable": true,
      "placeholder": "Select Date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.editForm['showfrom']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'showfrom', $$v)
      },
      expression: "editForm['showfrom']"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticClass: "startTimeBox",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "date",
      "clearable": true,
      "placeholder": "Select Date",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.editForm['showtill']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'showtill', $$v)
      },
      expression: "editForm['showtill']"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-upload2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butCancel))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butSave))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0959822e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/system/xnews.vue
// module id = 632
// module chunks = 1